module.exports = __webpack_public_path__ + "img/dce3bb994bfe20fa9913284ae6f969ef.png";